        let currentSlide = 0;
        const slider = document.getElementById('sliderWrapper');
        const dots = document.querySelectorAll('.dot');

        function goToSlide(index) {
            currentSlide = index;
            slider.style.transform = `translateX(-${currentSlide * 100}%)`;
            
            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === currentSlide);
            });
        }

        function copyCode(code, button) {
            navigator.clipboard.writeText(code).then(() => {
                const tooltip = button.nextElementSibling;
                button.classList.add('copied');
                tooltip.classList.add('show');

                setTimeout(() => {
                    button.classList.remove('copied');
                    tooltip.classList.remove('show');
                }, 2000);
            }).catch(err => {
                console.error('Failed to copy:', err);
                alert('Coupon code: ' + code);
            });
        }

        let autoSlide = setInterval(() => {
            currentSlide = (currentSlide + 1) % 3;
            goToSlide(currentSlide);
        }, 4000);

        document.querySelector('.slider-container').addEventListener('mouseenter', () => {
            clearInterval(autoSlide);
        });

        document.querySelector('.slider-container').addEventListener('mouseleave', () => {
            autoSlide = setInterval(() => {
                currentSlide = (currentSlide + 1) % 3;
                goToSlide(currentSlide);
            }, 4000);
        });